<template>
    <div class="curso-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>
                        <v-card-text>
                            <v-form ref="cursoForm" v-model="validCurso">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.financiamiento_tipo_id"
                                                :items="FINANCIAMIENTOS"
                                                label="Tipo de finaciamiento*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="financiamientoFieldRules"
                                                :error-messages="financiamientoFieldErrors"
                                                @blur="financiamientoFieldErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showTipoFinanciamientoForm = true"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.mes"
                                                :items="mesesItem"
                                                label="Primer pago*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="mesFieldRules"
                                                :error-messages="mesFieldErrors"
                                                @blur="mesFieldErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.campus_id"
                                                :items="CAMPUS"
                                                label="Campus*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="campusFieldRules"
                                                :error-messages="campusFieldErrors"
                                                @blur="campusFieldErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.seccion_id"
                                                :items="SECCIONES.filter(el => el.campus_id === cursoItem.campus_id)"
                                                label="Sección*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="seccionFieldRules"
                                                :error-messages="seccionFieldErrors"
                                                @blur="seccionFieldErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.grado_id"
                                                :items="
                                                    GRADOS.filter(
                                                        el =>
                                                            el.seccion_id === cursoItem.seccion_id &&
                                                            el.campus_id === cursoItem.campus_id
                                                    )
                                                "
                                                label="Grado*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="gradoFieldRules"
                                                :error-messages="gradoFieldErrors"
                                                @blur="gradoFieldErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showGradoForm = true"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="cursoItem.grupo_id"
                                                :items="
                                                    GRUPOS.filter(
                                                        el =>
                                                            el.grado_id === cursoItem.grado_id &&
                                                            el.seccion_id === cursoItem.seccion_id &&
                                                            el.campus_id === cursoItem.campus_id
                                                    )
                                                "
                                                label="Grupo"
                                                item-text="letra"
                                                item-value="id"
                                                :error-messages="grupoFieldErrors"
                                                @blur="grupoFieldErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showGrupoForm = true"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-autocomplete
                                                v-model="cursoItem.tarifa_id"
                                                label="Tarifa*"
                                                :rules="tarifa_idRules"
                                                :error-messages="tarifa_idErrors"
                                                @blur="tarifa_idErrors = []"
                                                :items="TARIFAS"
                                                item-text="nombre"
                                                item-value="id"
                                                hide-no-data
                                                hide-selected
                                                append-outer-icon="add"
                                                @click:append-outer="showTipoCicloTarifaForm = true"
                                            >
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title v-html="data.item.nombre">
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title
                                                            v-html="
                                                                CICLO.filter(el => el.id === data.item.tipo_ciclo_id)[0]
                                                                    .nombre
                                                            "
                                                        >
                                                        </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </template>
                                                <template v-slot:selection="data">
                                                    {{
                                                    data.item.nombre +
                                                    " (" +
                                                    CICLO.filter(el => el.id === data.item.tipo_ciclo_id)[0]
                                                    .nombre +
                                                    ")"
                                                    }}
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="cursoItem.colegiatura_descuento"
                                                label="Descuento*"
                                                type="number"
                                                :rules="colegiatura_descuentoFieldRules"
                                                :error-messages="colegiatura_descuentoFieldErrors"
                                                @change="setColegiaturaValue"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="cursoItem.colegiatura_base"
                                                label="Colegiatura*"
                                                :readonly="colegiaturaDisabled"
                                                :rules="colegiatura_baseFieldRules"
                                                :error-messages="colegiatura_baseFieldErrors"
                                                @change="colegiatura_baseFieldErrors = []"
                                                :append-icon="colegiaturaDisabled ? 'fa-edit' : 'fa-lock'"
                                            >
                                                <template slot="append">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon
                                                                v-on="on"
                                                                @click="colegiaturaDisabled = !colegiaturaDisabled"
                                                            >
                                                                {{ colegiaturaDisabled ? "fa-edit" : "fa-lock" }}
                                                            </v-icon>
                                                        </template>
                                                        <span>{{
                                                            colegiaturaDisabled
                                                                ? "Modificar valor"
                                                                : "Deshabilitar edición"
                                                        }}</span>
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="cursoItem.beca"
                                                :label="cursoItem.financiamiento_tipo_id === 3 ? 'Rebaja %' : 'Beca %'"
                                                type="number"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="cursoItem.inscripcion"
                                                label="Inscripción*"
                                                type="number"
                                                :rules="inscripcionFieldRules"
                                                :error-messages="inscripcionFieldErrors"
                                                @change="inscripcionFieldErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="cursoItem.reinscripcion"
                                                label="Reinscripción*"
                                                type="number"
                                                :rules="reinscripcionFieldRules"
                                                :error-messages="reinscripcionFieldErrors"
                                                @change="reinscripcionFieldErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <financiamiento-form
            v-if="showTipoFinanciamientoForm"
            form-title="Nuevo Tipo de Financiamiento"
            :initial-item="null"
            @formCanceled="showTipoFinanciamientoForm = false"
        >
        </financiamiento-form>
        <grado-form
            v-if="showGradoForm"
            form-title="Nuevo grado"
            :initial-item="null"
            @formCanceled="showGradoForm = false"
        ></grado-form>
        <grado-form
            v-if="showGradoForm"
            form-title="Nuevo grado"
            :initial-item="null"
            @formCanceled="showGradoForm = false"
        ></grado-form>
        <grado-grupo-form
            v-if="showGrupoForm"
            form-title="Nuevo grupo"
            :initial-item="null"
            @formCanceled="showGrupoForm = false"
        ></grado-grupo-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const GradoGrupoForm = () => import("@/components/cobranza/curso/grado-grupo-form")
const GradoForm = () => import("@/components/cobranza/nomencladores/grado-form/grado-form")
const FinanciamientoForm = () =>
    import("@/components/cobranza/nomencladores/tipo-financiamiento-form/financiamiento-form")

export default {
    components: { GradoGrupoForm, FinanciamientoForm, GradoForm },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null },
        estudianteId: { type: String, default: null }
    },
    data() {
        return {
            activeTab: 0,
            loading: false,
            validCurso: false,
            cursoItem: {
                grupo_id: "",
                grado_id: "",
                seccion_id: "",
                campus_id: "",
                financiamiento_tipo_id: "",
                tarifa_id: "",
                mes: "",
                colegiatura_base: "",
                colegiatura_descuento: "",
                inscripcion: "",
                reinscripcion: "",
                beca: ""
            },

            //formularios de los nomencladores
            showTipoFinanciamientoForm: false,
            showGradoForm: false,
            showGrupoForm: false,

            //alert errores de validacion
            showErrorAlert: false,

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false,

            //validaciones
            campusFieldRules: [v => !!v || "Debe proporcionar el campus"],
            campusFieldErrors: [],
            seccionFieldRules: [v => !!v || "Debe proporcionar la sección"],
            seccionFieldErrors: [],
            gradoFieldRules: [v => !!v || "Debe proporcionar el grado"],
            gradoFieldErrors: [],
            grupoFieldRules: [v => !!v || "Debe proporcionar el grupo"],
            grupoFieldErrors: [],
            financiamientoFieldRules: [v => !!v || "Debe proporcionar el tipo de financiamiento"],
            financiamientoFieldErrors: [],
            tarifa_idRules: [v => !!v || "Debe proporcionar la tarifa"],
            tarifa_idErrors: [],
            mesFieldRules: [v => !!v || "Debe proporcionar el mes del primer pago"],
            mesFieldErrors: [],
            colegiatura_baseFieldRules: [v => !!v || "Debe proporcionar la colegiatura base"],
            colegiatura_baseFieldErrors: [],
            colegiatura_descuentoFieldRules: [v => !!v || "Debe proporcionar el descuento de la colegiatura"],
            colegiatura_descuentoFieldErrors: [],
            inscripcionFieldRules: [v => !!v || "Debe proporcionar la inscripción"],
            inscripcionFieldErrors: [],
            reinscripcionFieldRules: [v => !!v || "Debe proporcionar la reinscripción"],
            reinscripcionFieldErrors: [],
            becaFieldErrors: [],

            //meses
            mesesItem: Util.yearMonths(),

            colegiaturaDisabled: true
        }
    },
    computed: {
        ...mapGetters(["CAMPUS", "SECCIONES", "GRADOS", "GRUPOS", "FINANCIAMIENTOS", "TARIFAS"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validCurso
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.cursoForm.validate()
            if (this.validCurso) {
                let curso = []
                curso = Object.assign(this.cursoItem)
                curso.estudiante_id = this.estudianteId

                if (!this.isNewRecord) {
                    curso.id = this.initialItem.id
                }

                this.$store.dispatch(this.isNewRecord ? "ADD_CURSO" : "UPDATE_CURSO", curso).then(result => {
                    if (!result) {
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            this.showErrorAlert = true
                            data.forEach(error => {
                                switch (error.field) {
                                    case "grado_id":
                                        this.gradoFieldErrors.push(error.message)
                                        break
                                    case "grupo_id":
                                        this.grupoFieldErrors.push(error.message)
                                        break
                                    case "seccion_id":
                                        this.seccionFieldErrors.push(error.message)
                                        break
                                    case "campus_id":
                                        this.campusFieldErrors.push(error.message)
                                        break
                                    case "financiamiento_tipo_id":
                                        this.financiamientoFieldErrors.push(error.message)
                                        break
                                    case "mes":
                                        this.mesFieldErrors.push(error.message)
                                        break
                                    case "colegiatura_base":
                                        this.colegiatura_baseFieldErrors.push(error.message)
                                        break
                                    case "colegiatura_descuento":
                                        this.colegiatura_descuentoFieldErrors.push(error.message)
                                        break
                                    case "inscripcion":
                                        this.inscripcionFieldErrors.push(error.message)
                                        break
                                    case "reinscripcion":
                                        this.reinscripcionFieldErrors.push(error.message)
                                        break
                                    case "beca":
                                        this.becaFieldErrors.push(error.message)
                                        break
                                    default:
                                        console.log(error.message)
                                }

                            })

                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        setColegiaturaValue() {
            this.colegiatura_descuentoFieldErrors = []

            this.cursoItem.colegiatura_base =
                this.cursoItem.colegiatura_descuento * 1.0 + 0.05 * this.cursoItem.colegiatura_descuento
            this.colegiaturaDisabled = true
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_GRADOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_GRUPOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_FINANCIAMIENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TARIFAS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.cursoItem = Object.assign({}, this.initialItem)
        }
    }
}
</script>

<style scoped></style>
